"use client";
import React from "react";
import ProgressBar from "@/components/ProgressBar";

interface FAQLayoutProps {
  children: React.ReactNode;
}

const FAQLayout: React.FC<FAQLayoutProps> = ({ children }) => {
  return (
    <div>
      <div className="absolute top-0 left-0 right-0 z-[1000]">
        <ProgressBar loading={false} />
      </div>
      {children}
    </div>
  );
};

export default FAQLayout;